import React, { Component, Fragment } from 'react';
import FormCheckbox from '../../../_shared/forms/FormCheckbox';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';

export default class PricingDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Price</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <p>
                            Cubic yardage price: &pound;
                            {this.props.providerJobTypePrice
                                ? (this.props.providerJobTypePrice * this.props.providerQty).toFixed(2) / 100
                                : ''}
                        </p>
                    </div>
                    <div className="col-md-6">
                        <p>
                            Total Job Price: &pound;
                            {this.props.provider_price_quoted === 'yes'
                                ? Number(this.props.provider_custom_price).toFixed(2)
                                : Number(this.props.providerTotalPrice).toFixed(2)}
                        </p>
                    </div>
                </div>
            </Fragment>
        );
    }
}
